import React, { useState, useEffect } from "react";
import { ReactSortable } from "react-sortablejs";
import {
  Alert,
  Container,
  Col,
  Form,
  Row,
  Spinner,
  Card,
  Button,
  ButtonGroup,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import messages from "../../../redux/messages";

import CustomNavbar from "../../../components/CustomNavbar";
import SidebarEvaluacionDesempenio from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import { getFactor } from "../../../redux/evaluacion_desempenio/Factor/actions";
import { getOrgs } from "../../../redux/organization/actions";
import { getEvaluationType } from "../../../redux/evaluacion_desempenio/EvaluationType/actions";
import Period from "../../../components/evaluacion_desempenio/Period";
import { getPeriodoEvaluaciones } from "../../../redux/evaluacion_desempenio/periodo_evaluacion/actions";
import {
  editPeriodicity,
  getPeriodicityById,
  getPeriodicityByOrg,
  getPeriodicityByOrgList,
  resetPeriodicityByOrg,
  savePeriodicity,
} from "../../../redux/evaluacion_desempenio/Periodicity/actions";
import moment from "moment";
import { getClassification } from "../../../redux/Classification/actions";

const Periodicity = (props) => {
  var d = new Date();
  var n = d.getFullYear();

  const [show, setShow] = useState(false);
  const [opcionesT, setOpcionesT] = useState([]);
  const [periodosT, setPeriodosT] = useState([]);
  const [empresa, setEmpresa] = useState("");
  const [periodo, setPeriodo] = useState("");
  const [isOrgSelect, setIsOrgSelect] = useState(false);
  const [isPeriodSelect, setIsPeriodSelect] = useState(false);
  const [order, setOrder] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [validated, setValidated] = useState(false);
  const [_anio, setAnio] = useState(n);
  const [filter, setFilter] = useState("");
  const [dragValue, setDragValue] = useState(null);
  const [isDateChange, setIsDateChange] = useState(false);
  const [isDateSelected, setIsDateSelected] = useState(false);

  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    empresa: Yup.string().required("**Campo requerido"),
    clasificacion: Yup.string().required("**Campo requerido"),
    periodo: Yup.string().required("**Campo requerido"),
    // peridoEmp: Yup.string().required("**Campo requerido"),
  });

  const {
    loading: loadingPeriodicity,
    saveLoading: saveLoadingPeriodicity,
    periodicity,
    periodicityError,
    formError: formErrorPeriodicity,
    loadingList,
    periodicityList,
  } = useSelector((store) => store.periodicity);

  const { loaderPeriodoEvaluacion, periodoEvaluacion } = useSelector(
    (store) => store.periodoEvaluacion
  );

  const data = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);

  const dataClasificacion = useSelector(
    (store) => store.classification.classification
  );
  const loadingClasificacion = useSelector(
    (store) => store.classification.loading
  );

  const {
    loading: loadingEvaluationType,
    saveLoading,
    evaluationTypesLength,
    evaluationTypes,
    evaluationTypeError,
    formError,
  } = useSelector((store) => store.evaluationType);

  evaluationTypes.sort((a, b) => {
    if (a.id && b.id) {
      if (a.id === b.id) {
        return 0;
      }
      if (a.id < b.id) {
        return -1;
      }
    }
    return 1;
  });

  // Métodos
  const getAClassification = (filt = filter) =>
    dispatch(
      getClassification(
        {
          filter: filt,
        },
        2
      )
    );

  useEffect(() => {
    // dispatch(getPeriodicityByOrg({}));
    dispatch(getFactor({}));
    dispatch(getOrgs(parseInt(2)));
    dispatch(getEvaluationType({}));
    dispatch(getPeriodoEvaluaciones({}));
    dispatch(resetPeriodicityByOrg());
    getAClassification({});
    // var d = new Date();
    // var n = d.getFullYear();
    // var select = [];
    // for (var i = 0; i < 100; i++) {
    //   select.push(n + i);
    // }
    // setAnio(select);
  }, []);

  useEffect(() => {
    if (periodicityList.length === 0) {
      dispatch(resetPeriodicityByOrg());
    } else {
      if (periodicityList && periodicityList.length > 0) {
        dispatch(
          getPeriodicityById(periodicityList[periodicityList.length - 1].id)
        );
      }
    }
  }, [periodicityList]);

  useEffect(() => {
    if (periodicity && periodicity.frecuencia) {
      setIsDateSelected(true);
      setIsPeriodSelect(true);
      var periodoTemp = [];
      for (let i = 1; i <= periodicity.list_frecuencia[0].cantidad_meses; i++) {
        periodoTemp.push(i);
      }
      setPeriodosT(periodoTemp);
    }
  }, [periodicity]);

  useEffect(() => {
    if (evaluationTypesLength > 0) {
      setOpcionesT(evaluationTypes.filter((e) => !e.requerido));
    }
  }, [evaluationTypes]);

  // useEffect(() => {
  //   if (order && opcionesT[parseInt(order)].requerido) {
  //     setOpcionesT(
  //       opcionesT.filter(
  //         (item) => item.id !== opcionesT[parseInt(order)].id && item.id !== 0
  //       )
  //     );
  //   }
  //   if (order && !opcionesT[parseInt(order)].requerido) {
  //     opcionesT
  //       .sort((a, b) => {
  //         if (a.id && b.id) {
  //           if (a.id === b.id) {
  //             return 0;
  //           }
  //           if (a.id < b.id) {
  //             return -1;
  //           }
  //         }
  //         return 1;
  //       })
  //       .map((item, index) => {
  //         const temp = opcionesT.filter((opt) => opt.nombre === item.nombre);
  //         if (
  //           // opcionesT[parseInt(index)] &&
  //           // opcionesT[parseInt(index + 1)] &&
  //           // opcionesT[parseInt(index)].id === opcionesT[parseInt(index + 1)].id
  //           temp.length === 2
  //         ) {
  //           let optTemp = opcionesT;
  //           optTemp = optTemp.filter(
  //             (value) =>
  //               !opcionesT.find(
  //                 (f) =>
  //                   temp[0].id === value.id &&
  //                   f.id === temp[0].id &&
  //                   item.id !== 0
  //               )
  //           );
  //           optTemp.push(temp[0]);
  //           setOpcionesT(
  //             optTemp.sort((a, b) => {
  //               if (a.id && b.id) {
  //                 if (a.id === b.id) {
  //                   return 0;
  //                 }
  //                 if (a.id < b.id) {
  //                   return -1;
  //                 }
  //               }
  //               return 1;
  //             })
  //           );
  //         } else {
  //           setOpcionesT(
  //             opcionesT.sort((a, b) => {
  //               if (a.id && b.id) {
  //                 if (a.id === b.id) {
  //                   return 0;
  //                 }
  //                 if (a.id < b.id) {
  //                   return -1;
  //                 }
  //               }
  //               return 1;
  //             })
  //           );
  //         }
  //         // if (
  //         //   opcionesT[parseInt(index)] &&
  //         //   opcionesT[parseInt(index + 1)] &&
  //         //   opcionesT[parseInt(index)].id === opcionesT[parseInt(index + 1)].id
  //         // ) {
  //         //   setOpcionesT(
  //         //     opcionesT.filter((item, _index) => _index !== parseInt(index + 1))
  //         //   );
  //         // }
  //       });
  //   }
  // }, [opcionesT, order]);

  useEffect(() => {
    if (order && dragValue && dragValue.requerido) {
      setOpcionesT(
        opcionesT
          .filter((item) => item.id !== dragValue.id)
          .sort((a, b) => {
            if (a.id && b.id) {
              if (a.id === b.id) {
                return 0;
              }
              if (a.id < b.id) {
                return -1;
              }
            }
            return 1;
          })
      );
      setOrder(false);
      setDragValue(null);
    }
    if (order && dragValue && !dragValue.requerido) {
      let valTemp = opcionesT.filter((opt) => opt.id !== dragValue.id);
      if (dragValue.id !== 0) {
        valTemp.push(dragValue);
      }
      setOpcionesT(
        valTemp.sort((a, b) => {
          if (a.id && b.id) {
            if (a.id === b.id) {
              return 0;
            }
            if (a.id < b.id) {
              return -1;
            }
          }
          return 1;
        })
      );
      setOrder(false);
      setDragValue(null);
    }
    if (order && !dragValue) {
      setOpcionesT(
        opcionesT.sort((a, b) => {
          if (a.id && b.id) {
            if (a.id === b.id) {
              return 0;
            }
            if (a.id < b.id) {
              return -1;
            }
          }
          return 1;
        })
      );
      setOrder(false);
      setDragValue(null);
    }
  }, [dragValue, order]);

  const onSubmit = async (req) => {
    if (
      window.confirm(
        "¿Estas seguro de realizar la evaluación con la periodicidad establecida?"
      )
    ) {
      if (
        window.confirm(
          "¿Si confirma, no se podra volver a modificar hasta que se cumpla la fecha de cierre, desea continuar bajo esos terminos?"
        )
      ) {
        const fecha = new Date();
        // const currentYear = fecha.getFullYear() + 1;
        fecha.setFullYear(fecha.getFullYear() + 1);
        req.frecuencia = req.periodo;
        req.fecha_inicio = `${_anio}-01-01`;
        req.fecha_fin = `${_anio}-12-31`;
        req.anio = _anio;
        // if (periodicity && !periodicity.id) {
        dispatch(savePeriodicity(req, setIsSubmit, setAnio));
        // } else {
        //   dispatch(editPeriodicity(req, periodicity.id, setIsSubmit));
        // }
      }
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarEvaluacionDesempenio show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">Periodicidad</h6>
          </div>
          <Col sm="12" md="12">
            <hr />
          </Col>
          {evaluationTypes.filter((e) => e.requerido) &&
            evaluationTypes.filter((e) => e.requerido).length > 0 && (
              <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
                <Col>
                  <div className="ml-1 my-1 border-left border-primary">
                    <Alert className="mb-2" variant="light">
                      <p>
                        <i className="material-icons">error_outline</i> La
                        evaluación{" "}
                        {evaluationTypes.filter((e) => e.requerido)[0].nombre}{" "}
                        grados se aplicara en cada periodo de evaluación.
                      </p>
                    </Alert>
                  </div>
                </Col>
              </div>
            )}
          <Col>
            <Col className="py-3 px-4 mb-3 border border-muted rounded shadow-sm">
              <Formik
                validationSchema={schema}
                onSubmit={(e) => {
                  if (!isDateSelected) {
                    onSubmit(e);
                  }
                }}
                initialValues={{
                  empresa: "",
                  clasificacion: "",
                  periodo:
                    periodicity && periodicity.frecuencia
                      ? periodicity.frecuencia
                      : "",
                  // peridoEmp:
                  //   periodicityList &&
                  //   periodicityList[periodicityList.length - 1]
                  //     ? periodicityList[periodicityList.length - 1].id
                  //     : "",
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  setFieldValue,
                  handleBlur,
                  values,
                  touched,
                  isValid,
                  errors,
                }) => (
                  <Form
                    onSubmit={handleSubmit}
                    noValidate
                    validated={validated}
                  >
                    {!!formErrorPeriodicity && (
                      <Alert variant="danger" className="my-0">
                        {formErrorPeriodicity}
                      </Alert>
                    )}
                    <Row className="mx-2">
                      <Col>
                        <Row className="md-pt-2 mx-0 justify-content-sm-start align-items-center flex-wrap">
                          <Form.Group
                            // md="6"
                            // s="auto"
                            className="md-mb-0 sm-mb-2 px-0"
                            as={Col}
                          >
                            <Row className="mb-0 d-flex flex-wrap align-items-center">
                              <Form.Label column md="3" xs="auto">
                                Empresa:
                              </Form.Label>
                              <Col md={8} xs="auto">
                                <Row className="d-flex flex-wrap align-items-center">
                                  <Col sm={loadingOrgs ? "10" : "12"}>
                                    <Form.Control
                                      as="select"
                                      id="empresa"
                                      name="empresa"
                                      className="col rounded-pill"
                                      isInvalid={
                                        touched.empresa && errors.empresa
                                      }
                                      isValid={
                                        touched.empresa && !errors.empresa
                                      }
                                      // onBlur={handleBlur("empresa")}
                                      value={values.empresa}
                                      // defaultValue={empresa}
                                      onChange={(e) => {
                                        setFieldValue("periodo", "");
                                        if (
                                          filter !== "" &&
                                          e.currentTarget.value !== ""
                                        ) {
                                          dispatch(
                                            getPeriodicityByOrgList(
                                              {
                                                tipo_busqueda: "empresa__id",
                                                filter: parseInt(
                                                  e.currentTarget.value
                                                ),
                                                tipo_busqueda_2:
                                                  "clasificacion_id",
                                                filter_2: parseInt(filter),
                                              },
                                              setAnio
                                            )
                                          );
                                          setIsOrgSelect(true);
                                          setIsPeriodSelect(false);
                                        } else {
                                          setIsOrgSelect(false);
                                          setIsPeriodSelect(false);
                                        }
                                        setIsSubmit(false);
                                        setPeriodo("");
                                        setEmpresa(e.currentTarget.value);
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        className="text-muted"
                                        value=""
                                        selected
                                        disabled
                                      >
                                        Selecionar Empresa
                                      </option>
                                      {data.length > 0 &&
                                        data.map((item) => (
                                          <option key={item.id} value={item.id}>
                                            {item.nombre}
                                          </option>
                                        ))}
                                    </Form.Control>
                                  </Col>
                                  {loadingOrgs && (
                                    <Col sm={1}>
                                      <Spinner animation="border" size="sm" />
                                    </Col>
                                  )}
                                </Row>
                              </Col>
                            </Row>
                          </Form.Group>
                          <Form.Group
                            // md="6"
                            // s="auto"
                            className="md-mb-0 sm-mb-2 px-0"
                            as={Col}
                          >
                            <Row className="mb-0 d-flex flex-wrap align-items-center">
                              <Form.Label column md="3" xs="auto">
                                Clasificación:
                              </Form.Label>
                              <Col md={8} xs="auto">
                                <Row className="d-flex flex-wrap align-items-center">
                                  <Col sm={loadingClasificacion ? "10" : "12"}>
                                    <Form.Control
                                      as="select"
                                      id="clasificacion"
                                      name="clasificacion"
                                      className="col rounded-pill"
                                      isInvalid={
                                        touched.clasificacion &&
                                        errors.clasificacion
                                      }
                                      isValid={
                                        touched.clasificacion &&
                                        !errors.clasificacion
                                      }
                                      // onBlur={handleBlur("clasificacion")}
                                      value={values.clasificacion}
                                      // defaultValue={clasificacion}
                                      onChange={(e) => {
                                        setFieldValue("periodo", "");
                                        setIsDateSelected(false);
                                        if (
                                          empresa !== "" &&
                                          e.currentTarget.value !== ""
                                        ) {
                                          dispatch(
                                            getPeriodicityByOrgList(
                                              {
                                                tipo_busqueda: "empresa__id",
                                                filter: parseInt(empresa),
                                                tipo_busqueda_2:
                                                  "clasificacion_id",
                                                filter_2: parseInt(
                                                  e.currentTarget.value
                                                ),
                                              },
                                              setAnio
                                            )
                                          );
                                          setIsOrgSelect(true);
                                          setIsPeriodSelect(false);
                                        } else {
                                          setIsOrgSelect(false);
                                          setIsPeriodSelect(false);
                                        }
                                        setIsSubmit(false);
                                        setPeriodo("");
                                        setFilter(e.currentTarget.value);
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        className="text-muted"
                                        value=""
                                        selected
                                        disabled
                                      >
                                        Selecionar clasificación
                                      </option>
                                      {dataClasificacion
                                        ? dataClasificacion.length > 0 &&
                                          dataClasificacion
                                            .sort((a, b) =>
                                              a.nombre > b.nombre
                                                ? 1
                                                : b.nombre > a.nombre
                                                ? -1
                                                : 0
                                            )
                                            .map((item) => (
                                              <option
                                                key={item.id}
                                                value={item.id}
                                              >
                                                {item.nombre ? item.nombre : ""}
                                              </option>
                                            ))
                                        : ""}
                                    </Form.Control>
                                  </Col>
                                  {loadingClasificacion && (
                                    <Col sm={1}>
                                      <Spinner animation="border" size="sm" />
                                    </Col>
                                  )}
                                </Row>
                              </Col>
                            </Row>
                          </Form.Group>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="mx-2">
                      <Col>
                        <Row className="md-pt-2 mx-0 justify-content-sm-start align-items-center flex-wrap">
                          <Form.Group
                            // md="6"
                            // xs="auto"
                            className="md-mb-2 sm-mb-0 px-0"
                            as={Col}
                          >
                            <Row className="mb-0 d-flex flex-wrap align-items-center">
                              <Form.Label column md="3" xs="auto">
                                Años configurados:
                              </Form.Label>
                              <Col md={8} xs="auto">
                                <Row className="d-flex flex-wrap align-items-center">
                                  {!loadingList ? (
                                    <>
                                      <Col sm={loadingList ? "10" : "12"}>
                                        <Form.Control
                                          as="select"
                                          id="peridoEmp"
                                          name="peridoEmp"
                                          className="col rounded-pill"
                                          // onBlur={handleBlur("peridoEmp")}
                                          // value={values.peridoEmp}
                                          defaultValue={
                                            periodicityList &&
                                            periodicityList.length > 0
                                              ? periodicityList[
                                                  periodicityList.length - 1
                                                ].id
                                              : ""
                                          }
                                          disabled={
                                            loadingList ||
                                            periodicityList.length === 0
                                          }
                                          onChange={(e) => {
                                            e.preventDefault();
                                            setIsSubmit(false);
                                            // setPeriodo("");
                                            // setEmpresa(e.currentTarget.value);
                                            if (e.currentTarget.value !== "") {
                                              dispatch(
                                                getPeriodicityById(
                                                  parseInt(
                                                    e.currentTarget.value
                                                  )
                                                )
                                              );
                                              // dispatch(
                                              //   getPeriodicityByOrg({
                                              //     tipo_busqueda: "empresa__id",
                                              //     filter: parseInt(
                                              //       // e.currentTarget.value
                                              //       empresa
                                              //     ),
                                              //     tipo_busqueda_2: "anio",
                                              //     filter_2: parseInt(
                                              //       e.currentTarget.value
                                              //     ),
                                              //   })
                                              // );
                                              // setIsOrgSelect(true);
                                              setIsPeriodSelect(false);
                                            } else {
                                              setIsDateSelected(false);
                                              dispatch(resetPeriodicityByOrg());
                                              // setIsOrgSelect(false);
                                              setIsPeriodSelect(false);
                                            }
                                            setFieldValue("periodo", "");
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            className="text-muted"
                                            value=""
                                            selected
                                          >
                                            Crear periodicidad
                                          </option>
                                          {periodicityList.map((item) => (
                                            <option
                                              key={item.id}
                                              value={item.id}
                                            >
                                              {item.anio}
                                            </option>
                                          ))}
                                        </Form.Control>
                                      </Col>
                                    </>
                                  ) : null}
                                  {loadingList ? (
                                    <Col sm={1}>
                                      <Spinner animation="border" size="sm" />
                                    </Col>
                                  ) : null}
                                </Row>
                              </Col>
                            </Row>
                          </Form.Group>
                          <Form.Group
                            // md="6"
                            // xs="auto"
                            className="md-mb-2 sm-mb-0 px-0"
                            as={Col}
                          >
                            <Row className="mb-0 d-flex flex-wrap align-items-center">
                              <Form.Label column md="3" xs="auto">
                                Periodicidad:
                              </Form.Label>
                              <Col md={8} xs="auto">
                                <Row className="d-flex flex-wrap align-items-center">
                                  <Col
                                    sm={
                                      loaderPeriodoEvaluacion ||
                                      loadingPeriodicity ||
                                      saveLoadingPeriodicity
                                        ? "10"
                                        : "12"
                                    }
                                  >
                                    <Form.Control
                                      as="select"
                                      id="periodo"
                                      name="periodo"
                                      className="col rounded-pill"
                                      // value={periodo}
                                      isInvalid={
                                        touched.periodo && errors.periodo
                                      }
                                      isValid={
                                        touched.periodo && !errors.periodo
                                      }
                                      // onBlur={handleBlur("periodo")}
                                      value={
                                        periodicity &&
                                        periodicity.id &&
                                        isDateSelected
                                          ? periodicity.frecuencia
                                          : values.periodo
                                      }
                                      disabled={
                                        (periodicity &&
                                          periodicity.id &&
                                          isDateSelected) ||
                                        !isOrgSelect
                                      }
                                      onChange={(e) => {
                                        // dispatch(
                                        //   getPeriodicityByOrg({
                                        //     tipo_busqueda: "frecuencia__id",
                                        //     filter: parseInt(
                                        //       e.currentTarget.value
                                        //     ),
                                        //   })
                                        // );
                                        setPeriodo(e.currentTarget.value);
                                        if (e.currentTarget.value !== "") {
                                          setIsPeriodSelect(true);
                                        } else {
                                          setIsPeriodSelect(false);
                                        }
                                        const valT =
                                          periodoEvaluacion.data.find(
                                            (p) =>
                                              p.id ===
                                              parseInt(e.currentTarget.value)
                                          );
                                        var periodoTemp = [];
                                        for (
                                          let i = 1;
                                          i <= valT.cantidad_meses;
                                          i++
                                        ) {
                                          periodoTemp.push(i);
                                        }
                                        setPeriodosT(periodoTemp);
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        className="text-muted"
                                        value=""
                                        selected
                                        disabled
                                      >
                                        Seleccione un periodo
                                      </option>
                                      {periodoEvaluacion &&
                                        periodoEvaluacion.data
                                          .sort((a, b) =>
                                            a.nombre > b.nombre
                                              ? 1
                                              : b.nombre > a.nombre
                                              ? -1
                                              : 0
                                          )
                                          .map((item) => (
                                            <option
                                              key={item.id}
                                              value={item.id}
                                            >
                                              {item.nombre}
                                            </option>
                                          ))}
                                    </Form.Control>
                                  </Col>
                                  {loaderPeriodoEvaluacion ||
                                  loadingPeriodicity ||
                                  saveLoadingPeriodicity ? (
                                    <Col sm={1}>
                                      <Spinner animation="border" size="sm" />
                                    </Col>
                                  ) : null}
                                </Row>
                              </Col>
                            </Row>
                          </Form.Group>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="mt-1 mx-2">
                      <Col>
                        <Row className="mx-0 justify-content-sm-between flex-nowrap">
                          <Form.Group
                            // md="6"
                            // xs="auto"
                            className="md-mb-2 sm-mb-0 px-0"
                            as={Col}
                          >
                            <Row className="mb-0 d-flex flex-wrap align-items-center">
                              <Form.Label column md="3" xs="auto">
                                Año:
                              </Form.Label>
                              <Col md={8} xs="auto">
                                <Row className="d-flex flex-wrap align-items-center">
                                  <Col sm={12}>
                                    <Form.Control
                                      className="col rounded-pill"
                                      type="text"
                                      value={
                                        periodicity && periodicity.anio
                                          ? periodicity.anio
                                          : _anio
                                      }
                                      disabled
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Form.Group>
                          <Form.Group
                            md="6"
                            xs="auto"
                            className="mb-0 px-0"
                            as={Col}
                          >
                            <Row className="mb-0 d-flex flex-wrap align-items-center">
                              <Form.Label column md="3" xs="auto">
                                Fecha de cierre:
                              </Form.Label>
                              <Col md={8} xs="auto">
                                {loadingPeriodicity ||
                                saveLoadingPeriodicity ? (
                                  <div className="d-flex justify-content-center">
                                    <Spinner
                                      animation="border"
                                      role="status"
                                      className="d-flex justify-content-center"
                                    />
                                  </div>
                                ) : (
                                  <>
                                    <Row>
                                      <Col sm="12">
                                        <Form.Control
                                          value={
                                            periodicity &&
                                            periodicity.id &&
                                            isDateSelected
                                              ? moment(
                                                  periodicity.fecha_fin
                                                ).format("DD/MM/YYYY")
                                              : ""
                                          }
                                          className="rounded-pill"
                                          type="text"
                                          disabled
                                        ></Form.Control>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                              </Col>
                            </Row>
                          </Form.Group>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="mt-1 mx-2">
                      <Col>
                        <Row className="mx-0 justify-content-sm-end flex-nowrap">
                          <Col className="mx-4 d-flex flex-wrap justify-content-end align-items-center">
                            <ButtonGroup className="mx-4">
                              {(periodicity && !periodicity.id) ||
                              !isDateSelected ? (
                                <Button
                                  className="rounded-pill d-flex flex-wrap justify-content-end align-items-center"
                                  disabled={
                                    saveLoadingPeriodicity ||
                                    (periodicity && periodicity.id) ||
                                    !isOrgSelect ||
                                    !isPeriodSelect
                                  }
                                  variant="primary"
                                  type="submit"
                                >
                                  {saveLoadingPeriodicity ||
                                  loadingPeriodicity ? (
                                    <Spinner
                                      className="mr-2"
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                  ) : null}
                                  Guardar
                                </Button>
                              ) : (
                                <Button
                                  className="rounded-pill d-flex flex-wrap justify-content-end align-items-center"
                                  variant="primary"
                                  type="button"
                                  onClick={() => {
                                    if (isDateSelected) {
                                      setIsDateChange(true);
                                    }
                                  }}
                                >
                                  {saveLoadingPeriodicity ||
                                  loadingPeriodicity ? (
                                    <Spinner
                                      className="mr-2"
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                  ) : null}
                                  Guardar
                                </Button>
                              )}
                            </ButtonGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
              <Row className="mt-5 mx-0">
                <Col md="3" className="px-0 mx-auto">
                  <Card
                    className="border border-muted rounded shadow-sm bg-white"
                    style={{ border: "1px solid #ced4da" }}
                  >
                    <Card.Header className="card-crear text-muted d-flex flex-wrap justify-content-center align-items-center text-justify">
                      <h6>Evaluaciones</h6>
                    </Card.Header>
                    <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
                      <Row className="justify-content-sm-center align-items-center flex-nowrap">
                        <Col md="12">
                          {loadingEvaluationType ||
                          loadingPeriodicity ||
                          saveLoadingPeriodicity ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              {opcionesT.length > 0 &&
                                periodicity &&
                                !periodicity.id && (
                                  <>
                                    <ReactSortable
                                      tag="span"
                                      list={opcionesT}
                                      setList={setOpcionesT}
                                      // onChange={(order, sortable, evt) => {
                                      //   editPosicion(order, sortable, evt);
                                      // }}
                                      group={{
                                        name: "list_evaluations",
                                        pull: "clone",
                                        put: true,
                                      }}
                                      onAdd={(order, sortable, evt) => {
                                        let dropValue = JSON.parse(
                                          order.item.dataset.value
                                        );
                                        // if (dropValue.requerido) {
                                        //   setOpcionesT(
                                        //     opcionesT.filter(
                                        //       (item) => item.id !== dropValue.id
                                        //     )
                                        //   );
                                        // }
                                        if (!dropValue.requerido) {
                                          opcionesT
                                            .sort((a, b) => {
                                              if (a.id && b.id) {
                                                if (a.id === b.id) {
                                                  return 0;
                                                }
                                                if (a.id < b.id) {
                                                  return -1;
                                                }
                                              }
                                              return 1;
                                            })
                                            .map((item, index) => {
                                              const temp = opcionesT.filter(
                                                (opt) =>
                                                  opt.nombre ===
                                                  dropValue.nombre
                                              );
                                              if (temp.length > 0) {
                                                let optTemp = opcionesT;
                                                optTemp = optTemp.filter(
                                                  (value) =>
                                                    dropValue.id !== value.id
                                                );
                                                setOpcionesT(
                                                  optTemp.sort((a, b) => {
                                                    if (a.id && b.id) {
                                                      if (a.id === b.id) {
                                                        return 0;
                                                      }
                                                      if (a.id < b.id) {
                                                        return -1;
                                                      }
                                                    }
                                                    return 1;
                                                  })
                                                );
                                              }
                                            });
                                        }
                                        setDragValue(dropValue);
                                        setOrder(true);
                                      }}
                                      animation={200}
                                      // handle=".dragI"
                                      sort={false}
                                      delayOnTouchOnly={true}
                                    >
                                      {opcionesT.map((item, index) => (
                                        <Col
                                          md="12"
                                          xs="auto"
                                          className="py-2 px-3 mb-2 border border-muted rounded shadow-sm dragPeriod"
                                          data-value={JSON.stringify(item)}
                                        >
                                          <div key={item.id}>{item.nombre}</div>
                                        </Col>
                                      ))}
                                    </ReactSortable>
                                  </>
                                )}
                              {opcionesT.length > 0 &&
                                periodicity &&
                                periodicity.id && (
                                  <>
                                    {opcionesT.map((item, index) => (
                                      <Col
                                        md="12"
                                        xs="auto"
                                        className="py-2 px-3 mb-2 border border-muted rounded shadow-sm"
                                      >
                                        <div key={item.id}>{item.nombre}</div>
                                      </Col>
                                    ))}
                                  </>
                                )}
                            </>
                          )}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md="8" className="mx-auto">
                  {loadingPeriodicity ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : (
                    <Row className="mx-0">
                      {isPeriodSelect &&
                        periodosT.map((item, index) => (
                          <>
                            <Period
                              item={item}
                              index={parseInt(index)}
                              isSubmit={isSubmit}
                              periodicity={periodicity}
                              valorRequerido={evaluationTypes.filter(
                                (e) => e.requerido
                              )}
                              list={opcionesT}
                              periodos={periodosT}
                              isDateChange={isDateChange}
                              setIsDateChange={setIsDateChange}
                            />
                            {/* <Col md="5" xs="auto" className="mx-auto">
                              <Card
                                className="mb-1 px-0 border border-muted rounded shadow-sm bg-white"
                                style={{ border: "1px solid #ced4da" }}
                              >
                                <Card.Header className="card-crear text-muted d-flex flex-wrap justify-content-center align-items-center text-justify">
                                  <h6>Periodo {parseInt(index) + 1}</h6>
                                </Card.Header>
                                <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
                                  <Period
                                    item={item}
                                    index={parseInt(index)}
                                    isSubmit={isSubmit}
                                    periodicity={periodicity}
                                    valorRequerido={evaluationTypes.filter(
                                      (e) => e.requerido
                                    )}
                                    list={opcionesT}
                                  />
                                </Card.Body>
                              </Card>
                              <Card
                                className="mb-3 px-0 border border-muted rounded shadow-sm bg-white"
                                style={{ border: "1px solid #ced4da" }}
                              >
                                <Card.Body className="py-2">
                                  <Form.Group as={Col} className="px-0 my-0">
                                    <Form.Label column sm="12" md="12">
                                      Fecha de evaluación:
                                    </Form.Label>
                                    <Form.Control
                                      id="nombre"
                                      name="nombre"
                                      // onChange={handleChange}
                                      // value={values.nombre}
                                      className="rounded-pill"
                                      type="date"
                                      placeholder="Tipo de evaluación"
                                      disabled={periodicity && !periodicity.id}
                                    ></Form.Control>
                                  </Form.Group>
                                </Card.Body>
                              </Card>
                            </Col>
                            {periodosT.length % 2 !== 0 &&
                              periodosT[parseInt(index) + 1] === undefined && (
                                <Col md="5" xs="auto" className="mx-auto"></Col>
                              )} */}
                          </>
                        ))}
                    </Row>
                  )}
                  {(periodosT.length === 0 || !isPeriodSelect) && (
                    <Alert variant="info" className="my-0">
                      Aún no se ha seleccionado ningun periodo.
                    </Alert>
                  )}
                  {!!periodicityError && (
                    <Alert variant="danger" className="my-0">
                      {periodicityError}
                    </Alert>
                  )}
                </Col>
              </Row>
            </Col>
          </Col>
        </Container>
      </div>
    </>
  );
};

export default Periodicity;
